import React from 'react'
import PropTypes from 'prop-types'
import { Heading } from 'components/util'
import styles from './_imageGrid.css'
import { DesktopView, TabletView, MobileView } from 'components/layout/responsive_container'
import SwipeableViews from 'react-swipeable-views'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'

const GridItem = ({ text, link, image, logEvent }) => {
  const imageStyles = {
    backgroundImage: `url('${image}')`,
  }

  return (
    <div
      style={imageStyles}
      className={styles.gridItem}
    >
      <a className={styles.gridLink} href={link} target="_blank" rel="noopener noreferrer"
        onClick={() => logEvent(link)} />
      <Heading
        desktopFontSize="28px"
        tabletFontSize="22px"
        mobileFontSize="28px"
        letterSpacing="2px"
        color="white"
        align="left"
        topBar={true}
      >
        <FormattedMessage {...text.message} />
      </Heading>
    </div>
  )
}

GridItem.propTypes = {
  text: PropTypes.object,
  link: PropTypes.string,
  image: PropTypes.string,
  logEvent: PropTypes.func,
}

const ImageGrid = props => {
  const {
    title,
    items,
    className,
    logEvent,
  } = props

  const gridItems = items.map((itemProps, index) => <GridItem {...itemProps} key={index} logEvent={logEvent} />)
  const classNames = classnames(styles.gridContainer, className)

  return (
    <div className={classNames}>
      { title ? <h2 className={styles.gridTitle}>{title}</h2> : null }
      <div className={styles.grid}>
        <MobileView>
          <SwipeableViews className={styles.slideContainer}>{gridItems}</SwipeableViews>
        </MobileView>
        <TabletView>{gridItems}</TabletView>
        <DesktopView>{gridItems}</DesktopView>
      </div>
    </div>
  )
}

ImageGrid.propTypes = {
  title: PropTypes.object,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.object,
      link: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
    }),
  ),
  className: PropTypes.string,
  logEvent: PropTypes.func,
}

export default ImageGrid
